import { useState } from 'react';
import pluralize from 'pluralize';

import * as Styled from './rating-stars.style';
import IconStarOutline from 'approot/shared/icons/icon-star-outline';

interface RatingStarsProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  maxRating?: number;
  disabled?: boolean;
}

const RatingStars = ({
  rating,
  onRatingChange,
  maxRating = 5,
  disabled = false,
}: RatingStarsProps) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleStarClick = (starRating: number) => {
    if (!disabled) {
      onRatingChange(starRating);
    }
  };

  const handleStarHover = (starRating: number) => {
    if (!disabled) {
      setHoverRating(starRating);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      setHoverRating(0);
    }
  };

  return (
    <Styled.StarButtonsContainer>
      {Array.from({ length: maxRating }, (_, index) => {
        const starNumber = index + 1;
        const isFilled = hoverRating
          ? starNumber <= hoverRating
          : starNumber <= rating;

        return (
          <Styled.StarButton
            key={starNumber}
            type="button"
            $filled={isFilled}
            onClick={() => handleStarClick(starNumber)}
            onMouseEnter={() => handleStarHover(starNumber)}
            onMouseLeave={handleMouseLeave}
            disabled={disabled}
            aria-label={`Rate ${starNumber} ${pluralize('star', starNumber)}`}
            aria-selected={isFilled}
          >
            <Styled.StarIconBox $filled={isFilled}>
              <IconStarOutline width={24} height={24} />
            </Styled.StarIconBox>
          </Styled.StarButton>
        );
      })}
    </Styled.StarButtonsContainer>
  );
};

export { RatingStars };
